<!-- <app-breadcrumb [pageName]="slug"></app-breadcrumb> -->
<main *ngIf="data">
	<section class="design-area ">
	<div class="container ">
		<div class="ck-content" [innerHTML]="data|safeHtml"></div>
	</div>
	</section>
</main>

<app-not-found *ngIf="!data"></app-not-found>